/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */

import * as alerts from '@bingads-webui-campaign-legacy/alerts-popup/view/alertsPopup';
import * as urls from '@bingads-webui-campaign-legacy/app/urls';
import * as stateManagerHelper from '@bingads-webui-campaign-legacy/bingadsgrid/service/state-manager-helper';
import * as customerHierachyPlugin from '@bingads-webui-campaign-legacy/bingadsgrid/vnext/plugin/customer-hierarchy-plugin';
import * as inlineDownloadPlugin from '@bingads-webui-campaign-legacy/bingadsgrid/vnext/plugin/inline-download';
import * as primaryContactsBulkEditPlugin from '@bingads-webui-campaign-legacy/bingadsgrid/vnext/plugin/primary-contacts-bulk-edit-plugin';
import * as bulkActionAccountsGrid from '@bingads-webui-campaign-legacy/bulk-action-accounts-grid/index';
import * as bulkTransferAccounts from '@bingads-webui-campaign-legacy/bulk-transfer-accounts/index';
import * as bulkUnlinkAccounts from '@bingads-webui-campaign-legacy/bulk-unlink-accounts/index';
import * as qualityScoreClickHandler from '@bingads-webui-campaign-legacy/common-grid-config/column/quality-score/quality-score-click-handler';
import qualityScoreTemplate from '@bingads-webui-campaign-legacy/common-grid-config/column/quality-score/quality-score-template.pug';
import sortableHeaderTemplate from '@bingads-webui-campaign-legacy/common-grid-config/column/sortableHeaderTemplate.pug';
import * as updateFilterSchema from '@bingads-webui-campaign-legacy/common-grid-config/filter/update-filter-schema-for-pilot-features';
import * as jsDataRawPlugin from '@bingads-webui-campaign-legacy/common-grid-plugins/js-data-raw-data';
import freqColumnTemplate from '@bingads-webui-campaign-legacy/scheduled-import/template/freq-column.pug';
import importLogNameTemplate from '@bingads-webui-campaign-legacy/scheduled-import/template/import-log-name.pug';
import creatorColumnTemplate from '@bingads-webui-campaign-legacy/scheduled-import/template/creator-column.pug';
import * as importSummaryCol from '@bingads-webui-campaign-legacy/scheduled-import/view/shared-column-configs/import-summary-col';
import * as singleUnlinkAccounts from '@bingads-webui-campaign-legacy/single-unlink-accounts/index';
import * as columnChooserPreference from '@bingads-webui-component-legacy/bingads-grid/service/column-chooser-preferences';
import * as customColumnPreference from '@bingads-webui-component-legacy/bingads-grid/service/custom-column-preferences';
import * as legacyColumnChooserPreference from '@bingads-webui-component-legacy/bingads-grid/service/legacy-column-chooser-preferences';
import * as linkedAccountsPreference from '@bingads-webui-component-legacy/bingads-grid/service/linked-accounts-preferences';
import * as segmentationPreference from '@bingads-webui-component-legacy/bingads-grid/service/segmentation-preferences';
import * as clientcenterUrlHelper from '@bingads-webui-component-legacy/bingads-grid/shared/clientcenter-url-helper';
import * as column from '@bingads-webui-component-legacy/bingads-grid/shared/column';
import * as icons from '@bingads-webui-component-legacy/bingads-grid/shared/icons';
import * as schemaUtil from '@bingads-webui-component-legacy/bingads-grid/shared/schema-util';
import config from '@bingads-webui-component-legacy/config/index';
import * as edmCampaign from '@bingads-webui-component-legacy/edm-campaign/index';
import * as eventDispatcher from '@bingads-webui-component-legacy/event-dispatcher/index';
import jsDataCampaign from '@bingads-webui-component-legacy/js-data-campaign/index';
import * as preferenceService from '@bingads-webui-component-legacy/preference/service/index';
import state from '@bingads-webui-component-legacy/state/index';
import instrumentation from '@bingads-webui-static-legacy/instrumentation/index';
import * as campaignInstrumentation from '@bingads-webui-campaign-legacy/instrumentation/index';
import legacyRouter from '@bingads-webui-component-legacy/legacy-router/index';
import * as i18nErrors from '@bingads-webui-component-legacy/api-errors-campaign/index';
import * as LabelAssociationView from '@bingads-webui-campaign-legacy/common-grid-plugins/label/label-association-view';
import { Account, AccountInactiveReason } from '@bingads-webui-campaign/campaign-ui-schemas';
import CacheService from '@bingads-webui-static-legacy/cache-service';
import SummaryDataContextManager from '@bingads-webui-static-legacy/summary/SummaryDataContextManager';

import { lazyLoadDeps } from './performance-lazy-deps';


export { loadInlineChartWithWebpack } from '@bingads-webui-campaign-react/inline-chart-factory-webpack';

const i18nGlobal = window.globalLegacyI18n.get('component/i18n/loader!legacy/global');
const accountSummaryi18n = window.globalLegacyI18n.get('@bingads-webui/i18n-amd-loader!campaignui/feature/accounts-summary');

const accountSchema = Account;
const accountInactiveReasonSchema = AccountInactiveReason;
const campaignSchema = window.globalLegacyI18n.get('$/schema-i18n!campaign');

export const accountsGridLegacyDepsListWebpack = {
  '$/i18n!legacy/global': i18nGlobal,
  '$/schema!campaign/Account': accountSchema,
  '$/schema!campaign/deps/AccountInactiveReason': accountInactiveReasonSchema,
  '$/schema-i18n!campaign': campaignSchema,
  '@bingads-webui/i18n-amd-loader!campaignui/feature/accounts-summary': accountSummaryi18n,
  'campaignui/feature/alerts-popup/view/alertsPopup': alerts,
  'campaignui/feature/app/urls': urls,
  'campaignui/feature/bingadsgrid/service/state-manager-helper': stateManagerHelper,
  'campaignui/feature/bingadsgrid/vnext/plugin/customer-hierarchy-plugin': customerHierachyPlugin,
  'campaignui/feature/bingadsgrid/vnext/plugin/inline-download': inlineDownloadPlugin,
  'campaignui/feature/bingadsgrid/vnext/plugin/primary-contacts-bulk-edit-plugin': primaryContactsBulkEditPlugin,
  'campaignui/feature/bulk-action-accounts-grid/index': bulkActionAccountsGrid,
  'campaignui/feature/bulk-transfer-accounts/index': bulkTransferAccounts,
  'campaignui/feature/bulk-unlink-accounts/index': bulkUnlinkAccounts,
  'campaignui/feature/common-grid-config/column/quality-score/quality-score-click-handler': qualityScoreClickHandler,
  'campaignui/feature/common-grid-config/column/quality-score/quality-score-template': qualityScoreTemplate,
  'campaignui/feature/common-grid-config/column/sortableHeaderTemplate': sortableHeaderTemplate,
  'campaignui/feature/common-grid-config/filter/update-filter-schema-for-pilot-features': updateFilterSchema,
  'campaignui/feature/common-grid-plugins/js-data-raw-data': jsDataRawPlugin,
  'campaignui/feature/scheduled-import/template/freq-column': freqColumnTemplate,
  'campaignui/feature/scheduled-import/template/import-log-name': importLogNameTemplate,
  'campaignui/feature/scheduled-import/template/creator-column': creatorColumnTemplate,
  'campaignui/feature/scheduled-import/view/shared-column-configs/import-summary-col': importSummaryCol,
  'campaignui/feature/single-unlink-accounts/index': singleUnlinkAccounts,
  'component/bingads-grid/service/column-chooser-preferences': columnChooserPreference,
  'component/bingads-grid/service/custom-column-preferences': customColumnPreference,
  'component/bingads-grid/service/legacy-column-chooser-preferences': legacyColumnChooserPreference,
  'component/bingads-grid/service/linked-accounts-preferences': linkedAccountsPreference,
  'component/bingads-grid/service/segmentation-preferences': segmentationPreference,
  'component/bingads-grid/shared/clientcenter-url-helper': clientcenterUrlHelper,
  'component/bingads-grid/shared/column': column,
  'component/bingads-grid/shared/icons': icons,
  'component/bingads-grid/shared/schema-util': schemaUtil,
  'component/config/index': config,
  'component/edm-campaign/index': edmCampaign,
  'component/event-dispatcher/index': eventDispatcher,
  'component/js-data-campaign/index': jsDataCampaign,
  'component/preference/service/index': preferenceService,
  'component/state/index': state,
  'module/service/instrumentation/index': instrumentation,
  'campaignui/feature/instrumentation/index': campaignInstrumentation,
  'component/legacy-router/index': legacyRouter,
  'component/api-errors-campaign/index': i18nErrors,
  'campaignui/feature/common-grid-plugins/label/label-association-view': LabelAssociationView,
  'Services/CacheService': CacheService,
  SummaryDataContextManager,
};

export const lazyLoadDep = () => lazyLoadDeps;

export const getBulkUnlinkAccounts = () => bulkUnlinkAccounts.default;
export const getBulkTransferAccounts = () => bulkTransferAccounts.default;
export const getBulkActionAccountsGrid = () => bulkActionAccountsGrid;
export const getjsDataCampaign = () => jsDataCampaign;
